import {
  faEdit,
  faTrash,
  faCheck,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import {
  faInfoCircle,
  faSortDown,
  faSortUp,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, FieldArray, useFormikContext } from "formik";
import { forEach, get, isEmpty } from "lodash";
import React from "react";
import { useState } from "react";
import { useDeepEffect } from "../../abstracts";
import { filterOutLastFeeTier } from "../../containers/Fee/CalculationContainer/CreateSpecificationSlider";
import {
  FieldInputBasisPoint,
  FieldInputDollar,
  FieldInputNumber,
  FieldInputPercentage,
  FieldInputPercentageBox,
} from "../Forms";
import AddToolTip from "../AddToolTip/AddToolTip";

const TieredFeesCard = ({
  tableHeader,
  ind,
  push,
  remove,
  fields,
  isEdit,
  isSave,
}) => {
  const {
    handleChange,
    values,
    setFieldValue,
    setValues,
    setFieldError,
    setFieldTouched,
    errors,
  } = useFormikContext();
  console.log("errors", errors, isEdit, isSave, values);
  const isEmptyField = (fieldName) =>
    [undefined, null, ""].includes(get(values, fieldName));
  // const [isEditMode, setIsEditMode] = useState(
  //   get(values, `${fields.feeTiers}.${ind}.isEditMode`, false)
  // );
  const isEditMode = get(values, `${fields.feeTiers}.${ind}.isEditMode`, false);
  const setIsEditMode = (value) =>
    setFieldValue(`${fields.feeTiers}.${ind}.isEditMode`, value);

  const [initialState, setInitialState] = useState({});
  const data = values[fields.feeTiers][ind];

  const fieldNameAccountBalanceFrom = `${fields.feeTiers}.${ind}.from`;
  const fieldNameAccountBalanceTo = `${fields.feeTiers}.${ind}.to`;
  const fieldNameFeeAmount = `${fields.feeTiers}.${ind}.percentageOrAmountOrBasisPoints`;
  console.log(isEmpty(get(errors, `${fields.feeTiers}.${ind}.to`)), "kiududu");

  const accountBalanceFromTo = isEditMode ? (
    <>
      <div className="account-balance-from-to" style={{ whiteSpace: "normal" }}>
        <Field
          size="xs"
          className="mr-2"
          isRequired
          type="text"
          autoComplete="off"
          name={fieldNameAccountBalanceFrom}
          value={get(values, `${fields.feeTiers}.${ind - 1}.to`, 0)}
          onChange={handleChange}
          disabled
          precision={2}
          component={FieldInputDollar}
        />
        <Field
          size="xs"
          isRequired
          type="text"
          autoComplete="off"
          name={fieldNameAccountBalanceTo}
          value={get(values, fieldNameAccountBalanceTo)}
          onChange={handleChange}
          disabled={isEdit && !isSave}
          precision={2}
          component={FieldInputDollar}
        />
      </div>
    </>
  ) : (
    <>
      {["", null].includes(get(values, `${fields.feeTiers}.${ind}.to`)) ? (
        <>
          $ {get(values, `${fields.feeTiers}.${ind - 1}.to`, 0)}{" "}
          <span>and above</span>
        </>
      ) : (
        <>
          $ {get(values, `${fields.feeTiers}.${ind - 1}.to`, 0)}{" "}
          <span style={{ color: "#919191" }}>to</span> ${" "}
          {get(values, `${fields.feeTiers}.${ind}.to`)}
        </>
      )}
    </>
  );

  console.log(get(values, `${fields.feeTiers}.${ind}.to`) == "", "apodo");

  const feePercentageField = isEditMode ? (
    values[fields.tierComputationSubType] === 1 ? (
      <Field
        size="xs"
        isRequired
        type="text"
        autoComplete="off"
        name={fieldNameFeeAmount}
        value={get(values, fieldNameFeeAmount)}
        onChange={handleChange}
        disabled={isEdit && !isSave}
        precision={2}
        component={FieldInputDollar}
      />
    ) : (
      <div className="d-flex">
        <Field
          size={values[fields.formulaType] === 1 ? "xxs" : "xs"}
          isRequired
          type="text"
          autoComplete="off"
          name={fieldNameFeeAmount}
          value={get(values, fieldNameFeeAmount)}
          onChange={handleChange}
          disabled={isEdit && !isSave}
          precision={2}
          component={
            values[fields.formulaType] === 1
              ? FieldInputPercentage
              : FieldInputBasisPoint
          }
        />{" "}
        {/* {values[fields.formulaType] === 2 && (
          <span className="mt-2 ml-2">BP</span>
        )} */}
      </div>
    )
  ) : (
    `${values[fields.tierComputationSubType] === 1 ? "$" : ""} ${get(
      values,
      fieldNameFeeAmount,
      "-"
    )} ${
      values[fields.tierComputationSubType] === 2
        ? values[fields.formulaType] === 1
          ? "%"
          : "BP"
        : ""
    }`
  );
  const disabled = isEdit && !isSave;
  values[fields?.feeTiers][0].from = 0;

  return (
    <div className=" tiered-fees-card" onClick={() => {}}>
      {tableHeader.map((col, index) => {
        return (
          <div
            // className="d-flex align-items-center"
            style={{ width: col.width }}
          >
            <div
              style={{
                cursor: "pointer",
                marginLeft: "10px",
                whiteSpace: "nowrap",
                paddingLeft: "25px",
                paddingTop: "20px",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "20px",
                color: "#242426",
                height: "100%",
              }}
            >
              {col.columnName === "accountBalanceFromTo" ? (
                accountBalanceFromTo
              ) : col.columnName === "feePercentage" ? (
                feePercentageField
              ) : col.columnName === "action" ? (
                <div className="d-flex">
                  {!isEditMode ? (
                    <>
                      <FontAwesomeIcon
                        icon={faEdit}
                        className={`mr-2 ${disabled ? "opacity-75" : ""}`}
                        size="xs"
                        onClick={() => {
                          if (!disabled) {
                            setInitialState(data);
                            setIsEditMode(true);
                          }
                        }}
                      />
                      <FontAwesomeIcon
                        icon={faTrash}
                        className={`${disabled ? "opacity-75" : ""}`}
                        size="xs"
                        onClick={() => {
                          if (!disabled) {
                            remove(ind);
                            if (ind - 1 < 0)
                              setFieldValue(
                                `${fields.feeTiers}.${ind}.from`,
                                0
                              );
                            else
                              setFieldValue(
                                `${fields.feeTiers}.${ind}.from`,
                                get(values, `${fields.feeTiers}.${ind - 1}.to`)
                              );
                          }
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <div>
                        {console.log(
                          "abcd",
                          ind == values[fields.feeTiers].length - 1
                        )}
                        {console.log(
                          "defc",
                          ind,
                          values[fields.feeTiers].length - 1
                        )}
                        <FontAwesomeIcon
                          icon={faCheck}
                          className={`mr-2 ${disabled ? "opacity-75" : ""}`}
                          size="xs"
                          onClick={() => {
                            {
                              ind > 0 &&
                                setFieldValue(
                                  `${fields.feeTiers}.${ind}.from`,
                                  get(
                                    values,
                                    `${fields.feeTiers}.${ind - 1}.to`
                                  )
                                );
                            }

                            if (!disabled) {
                              setFieldError(`${fields.feeTiers}.${ind}`, {});
                              let errorMessages = [];
                              [
                                fieldNameAccountBalanceFrom,
                                fieldNameAccountBalanceTo,
                                fieldNameFeeAmount,
                              ].forEach((field) => {
                                if (isEmptyField(field)) {
                                  if (field === fieldNameFeeAmount) {
                                    let requiredError = "FE030: Required";
                                    errorMessages.push(requiredError);
                                    setFieldTouched(field, true);
                                    setFieldError(field, requiredError);
                                    setIsEditMode(true);
                                  } else if (
                                    field === fieldNameAccountBalanceTo
                                  ) {
                                    if (
                                      ind !==
                                      values[fields.feeTiers].length - 1
                                    ) {
                                      let requiredError = "FE028: Required";
                                      errorMessages.push(requiredError);
                                      setFieldTouched(field, true);
                                      setFieldError(field, requiredError);
                                      // setIsEditMode(true);
                                    } else {
                                      setIsEditMode(false);
                                    }
                                  }
                                }

                                if (
                                  !isEmptyField(field) &&
                                  get(
                                    values,
                                    `${fields.feeTiers}.${ind}.from`
                                  ) >=
                                    get(values, `${fields.feeTiers}.${ind}.to`)
                                ) {
                                  let requiredError =
                                    field === fieldNameAccountBalanceTo &&
                                    "FE027: To value should not be lesser than or equal to the From Value";
                                  errorMessages.push(requiredError);
                                  setFieldTouched(field, true);
                                  setFieldError(field, requiredError);
                                } else if (
                                  !isEmptyField(field) &&
                                  get(values, `${fields.feeTiers}.${ind}.to`) >=
                                    get(
                                      values,
                                      `${fields.feeTiers}.${ind + 1}.to`
                                    ) &&
                                  ind + 1 !== values[fields.feeTiers].length - 1
                                ) {
                                  let requiredError =
                                    field === fieldNameAccountBalanceTo &&
                                    "FE025 : To Value conflicts with other Tier ranges";
                                  errorMessages.push(requiredError);
                                  setFieldTouched(field, true);
                                  setFieldError(field, requiredError);
                                }

                                // if(errorMessages[0]== false && errorMessages[1]== false && errorMessages[2]== false)
                                // {
                                //   setIsEditMode(false)
                                // }
                              });

                              console.log("error67", errorMessages[2]);

                              if (errorMessages.length === 0) {
                                setIsEditMode(false);
                                if (ind === values[fields.feeTiers].length - 1)
                                  push({
                                    from: get(
                                      values,
                                      `${fields.feeTiers}.${ind}.to`
                                    ),
                                    to: "",
                                    percentageOrAmountOrBasisPoints: "",
                                    isEditMode: true,
                                  });
                              }
                            }
                          }}
                        />
                      </div>
                      <div className="fw-500 ft-14 checkIcon">Save</div>

                      <div className="ml-4">
                        <FontAwesomeIcon
                          icon={faTimes}
                          size="xs"
                          className={`${disabled ? "opacity-75" : ""}`}
                          onClick={() => {
                            if (
                              get(values, `${fields.feeTiers}.${ind}.to`) ==
                                "" ||
                              get(
                                values,
                                `${fields.feeTiers}.${ind}.percentageOrAmountOrBasisPoints`
                              ) == ""
                            ) {
                              setIsEditMode(true);
                            } else if (
                              get(values, `${fields.feeTiers}.${ind}.to`) !==
                                "" ||
                              get(
                                values,
                                `${fields.feeTiers}.${ind}.percentageOrAmountOrBasisPoints`
                              ) !== ""
                            ) {
                              setFieldValue(`${fields.feeTiers}.${ind}`, {
                                to: "",
                                percentageOrAmountOrBasisPoints: "",
                              });
                              setIsEditMode(true);
                            }
                          }}
                        />
                      </div>
                      <div className="fw-500 ft-14 resetIcon">Reset</div>
                    </>
                  )}
                </div>
              ) : col.columnName === "sno" ? (
                `${ind + 1}`
              ) : (
                ""
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

function TieredFeesTable(props) {
  const { fields, isEdit, isSave } = props;
  const {
    values,
    handleChange,
    setFieldValue,
    errors,
    touched,
  } = useFormikContext();
  const tableHeader = [
    {
      label: "SNo.",
      columnName: "sno",
      width: "10%",
    },
    {
      label: "Account balance from / to",
      columnName: "accountBalanceFromTo",
      width: "45%",
    },
    {
      label:
        values[fields.tierComputationSubType] === 1
          ? "Fixed amount"
          : values[fields.formulaType] === 1
          ? "Fee percentage"
          : "Basis points",
      columnName: "feePercentage",
      width: "25%",
    },
    {
      label: "Action",
      columnName: "action",
      width: "20%",
    },
  ];

  const feeTiers = get(values, "feeTiers", []);

  return (
    <div className="tiered-fees-table w-100">
      <div className="tiered-fees-table-header">
        {tableHeader.map((_, ind) => (
          <div
            style={{ width: _?.width }}
            className="withdrawal-Text-Color d-flex ft-12 pd-l-25"
          >
            {_.columnName == "accountBalanceFromTo" && (
              <AddToolTip
                name={`Account Balance From – Greater than, Account Balance To – Lesser than or Equal to`}
              >
                <FontAwesomeIcon className="mr-1 ft-16" icon={faInfoCircle} />
              </AddToolTip>
            )}
            {_?.label}{" "}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "8px",
                marginTop: "-3px",
              }}
            >
              <div style={{ paddingLeft: "10px" }}>
                <FontAwesomeIcon
                  icon={faSortUp}
                  size="xs"
                  style={{
                    cursor: "pointer",
                    marginRight: "-6px",
                    marginBottom: "3px",
                  }}
                  onClick={() => {
                    values.Data.sort((a, b) =>
                      a[_.columnName].localeCompare(b[_.columnName])
                    );
                  }}
                />

                <FontAwesomeIcon
                  icon={faSortDown}
                  size="xs"
                  style={{ cursor: "pointer", marginRight: "-10px" }}
                  onClick={() => {
                    values.Data.sort((b, a) =>
                      a[_.columnName].localeCompare(b[_.columnName])
                    );
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="tiered-fees-table-body">
        <FieldArray
          name={fields.feeTiers}
          render={({ push, remove }) => (
            <>
              {feeTiers?.map((_, ind) => (
                <TieredFeesCard
                  tableHeader={tableHeader}
                  data={_}
                  ind={ind}
                  {...props}
                  push={push}
                  remove={remove}
                />
              ))}
            </>
          )}
        />
      </div>
    </div>
  );
}

export default TieredFeesTable;
